import { api } from "@/lib/axios"
import type { Worker, WorkersResponse, WorkerDetailResponse, PriceReference, PriceReferencesResponse, WorkerProduct, WorkerProductsResponse } from "@/types/workers"
import type { CreateExpenseResponse } from "@/types/company-expenses"

export async function fetchWorkers(): Promise<Worker[]> {
  const { data } = await api.get<WorkersResponse>("/workers/")
  return data.data
}

export async function fetchWorkerDetail(id: number): Promise<Worker> {
  const { data } = await api.get<WorkerDetailResponse>(`/admin/workers/${id}/`)
  return data.data
}

export async function updateWorkerStatus(
  id: number,
  status: Worker["worker_status"]
): Promise<Worker> {
  const { data } = await api.patch<WorkerDetailResponse>(`/admin/workers/${id}/`, {
    worker_status: status,
  })
  return data.data
}

export async function fetchPriceReferences(): Promise<PriceReference[]> {
  const { data } = await api.get<PriceReferencesResponse>("/workers/price-references/")
  return data.data
}

export async function updatePriceReference(
  id: number,
  priceData: { square: string; price: number }
): Promise<PriceReference> {
  const { data } = await api.patch<{ status: number; message: string; data: PriceReference }>(
    `/workers/price-references/${id}/`,
    priceData
  )
  return data.data
}

export async function deletePriceReference(id: number): Promise<void> {
  await api.delete(`/workers/price-references/${id}/`)
}

export async function createPriceReference(
  priceData: { square: string; price: number }
): Promise<PriceReference> {
  const { data } = await api.post<{ status: number; message: string; data: PriceReference }>(
    "/workers/price-references/",
    priceData
  )
  return data.data
}

export async function fetchWorkerProducts(workerId: number): Promise<WorkerProduct[]> {
  const { data } = await api.get<WorkerProductsResponse>(`/workers/${workerId}/products`)
  return data.data
}

export async function createWorkerSalary(
  workerId: number,
  payload: { amount: string; description?: string | null }
): Promise<CreateExpenseResponse> {
  const expensePayload = {
    ...payload,
    revenue_type: 'outcome',
    expense_type: 'salary',
    worker: workerId,
  }
  const { data } = await api.post<CreateExpenseResponse>('/admin/company-expenses/', expensePayload)
  return data
}
